import type { LucideIcon } from 'lucide-react';
import type { ComponentType, LazyExoticComponent } from 'react';

// Every utility ID in the hub. Reference IDs as `UtilityId.AccMassUpload` instead of raw strings; the same name doubles as the union type. Each ID is used in the `utilityRegistry`, `usePermissions`, and `RequireUtilityAccess`.
export const UtilityId = {
  AccMassUpload: 'acc-mass-upload',
  ManagePermissions: 'manage',
} as const;

// eslint-disable-next-line no-redeclare -- intentional value + type pair sharing one name
export type UtilityId = (typeof UtilityId)[keyof typeof UtilityId];

export interface UtilityDefinition {
  description: string;
  element: LazyExoticComponent<ComponentType>;
  icon: LucideIcon;
  id: UtilityId;
  owner: string;
  path: string;
  title: string;
}
